class GetRequestPathAIResult {
    Status: number;
    Rows: any[];
    NextPage: string;

    constructor(status: number, rows: any[], nextPage: string) {
        this.Status = status;
        this.Rows = rows;
        this.NextPage = nextPage;
    }
}

export default GetRequestPathAIResult;
